module.exports = __webpack_public_path__ + "media/images/area/area_tottoriM400-fb30150de4b2acc9ef632f45c3d57bd8.jpg";